<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR LÍNEAS DE PROCESO</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre Línea*',key:'nombre_linea'},
            {tipo:'texto',valor:'',label:'Nombre Corto*',key:'nombre_corto'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Id',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'id',
                    class:'cabecera'
                },
                {
                    text: 'Nombre Línea',
                    align: 'center',
                    sortable: true,
                    value: 'nombre_linea',
                    class:'cabecera'
                },
                {
                    text: 'Nombre Corto',
                    align: 'center',
                    sortable: true,
                    value: 'nombre_corto',
                    class:'cabecera'
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarDatos()
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...')
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}lineas`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones)
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Línea'
            this.configuracion_modal.boton_submit = 'Crear'
            this.configuracion_modal.ruta = 'lineas'
            this.configuracion_modal.tipo_peticion = 'POST'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Línea'
            this.configuracion_modal.boton_submit = 'Actualizar'
            this.configuracion_modal.ruta = `lineas/${$event.id}`
            this.configuracion_modal.tipo_peticion = 'PUT'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>